export default __webpack_public_path__ + "static/media/slidecompus1.f77159da.png";